/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyInstrument} from '../api'

export const useMutationVerifyInstrument = createReactQueryMutationHook('verifyInstrument', verifyInstrument)
